import { H1 } from 'src/components/common/typography/Header';
import styled, { css } from 'styled-components';
import { media } from 'src/styles/designs';
import { CleanButton } from 'src/components/common/Button';
import { fromTheme } from 'src/styles/theme';
import { motion } from 'framer-motion';

export const TabHeader = styled.h2`
  font-weight: inherit;
  font-size: 16px;
  line-height: 131%;
`;
export const TabDescription = styled.div`
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0rpx;
`;

export const NailTab = styled(H1).attrs({ as: motion(CleanButton) })<{
  $active?: boolean;
}>`
  display: grid;
  grid-auto-flow: row;
  grid-gap: 2px !important;
  text-transform: unset;
  text-align: left;
  margin-bottom: 0;
  color: ${({ theme }) => theme.buttons.default.primary.default.primary};
  padding-left: 26px;
  font-weight: 700;

  &:not(:first-of-type) {
    margin-left: 20px;

    ${media.w.greaterThanOrEqual.desktop} {
      margin-left: 30px;
    }
  }

  :before {
    top: -1px;
    width: 12px;
    height: 50px;
    transition: background-color ${fromTheme((t) => t.animation.duration)}s
      ${fromTheme((t) => t.animation.duration / 4)}s
      ${fromTheme((t) => t.animation.easing.default)};
  }

  transition: color ${fromTheme((t) => t.animation.duration)}s
    ${fromTheme((t) => t.animation.duration / 4)}s
    ${fromTheme((t) => t.animation.easing.default)};

  ${({ $active }) =>
    $active === false
      ? css`
          &:not([disabled]) {
            font-weight: 500;
            color: ${({ theme }) =>
              theme.buttons.default.primary.disabled.primary};

            &::before {
              background-color: ${({ theme }) =>
                theme.buttons.default.primary.disabled.primary};
            }

            &:hover,
            &:focus {
              color: ${({ theme }) =>
                theme.buttons.default.primary.default.primary};
              &:before {
                background-color: ${({ theme }) =>
                  theme.buttons.default.primary.default.primary};
              }
            }
          }
        `
      : ''}
`;
